export const serverUrl = "https://yardireportapi.datastems.com";
// export const serverUrl = "http://104.198.207.152";

// export const serverUrl = "http://sever1:8080";
// export const serverUrl = "http://sever2:8080";
// export const serverUrl = "http://sever3:8080";
